import React from 'react';

export const SHEET_W = 703; // 186mm printable width @96dpi
export const PAGE_H_PX = Math.round((273 / 186) * SHEET_W); // printable A4 height at that width
export const FONT = { sm: 12, md: 13.5, lg: 15 };

// Safe mini-markdown: **bold**, *italic*, line breaks (no HTML injection).
export function Rich({ text }) {
  const lines = String(text || '').split('\n');
  return lines.map((ln, i) => (
    <React.Fragment key={i}>
      {ln.split(/(\*\*[^*]+\*\*|\*[^*]+\*)/g).map((p, j) => {
        if (/^\*\*[^*]+\*\*$/.test(p)) return <b key={j}>{p.slice(2, -2)}</b>;
        if (/^\*[^*]+\*$/.test(p)) return <i key={j}>{p.slice(1, -1)}</i>;
        return <React.Fragment key={j}>{p}</React.Fragment>;
      })}
      {i < lines.length - 1 && <br />}
    </React.Fragment>
  ));
}

export const watermarkBg = (text) => {
  if (!text) return null;
  const safe = text.replace(/[<>&"']/g, '');
  const svg = `<svg xmlns='http://www.w3.org/2000/svg' width='${SHEET_W}' height='${PAGE_H_PX}'><text x='50%' y='50%' text-anchor='middle' font-family='serif' font-size='64' font-weight='700' fill='rgba(0,0,0,0.06)' transform='rotate(-30 ${SHEET_W / 2} ${PAGE_H_PX / 2})'>${safe}</text></svg>`;
  return `url("data:image/svg+xml;utf8,${encodeURIComponent(svg)}")`;
};

export const CSS = `
.qpb-sheet{width:${SHEET_W}px;background:#fff;color:#000;font-family:'Noto Serif','Times New Roman',serif;line-height:1.45;box-sizing:border-box;position:relative}
.qpb-sheet *{box-sizing:border-box;font-style:normal}
.qpb-sheet i{font-style:italic}
.qpb-head{text-align:center;border-bottom:2px solid #000;padding-bottom:8px;margin-bottom:8px}
.qpb-head-row{display:flex;align-items:center;justify-content:center;gap:14px}
.qpb-head img{width:62px;height:62px;object-fit:contain}
.qpb-school{font-size:1.9em;font-weight:700;letter-spacing:1.5px;text-transform:uppercase;margin:0}
.qpb-banner{text-align:center;font-weight:700;font-size:1.1em;text-transform:uppercase;margin:6px 0}
.qpb-conf{text-align:center;font-weight:700;border:2px solid #000;padding:3px;margin:6px 0;letter-spacing:2px}
.qpb-meta{display:grid;grid-template-columns:1fr 1fr;border:1px solid #000;margin-bottom:8px}
.qpb-meta div{padding:3px 8px;border:1px solid #000;margin:-.5px}
.qpb-instr ol{margin:3px 0 0 18px;padding:0}
.qpb-sec{text-align:center;font-weight:700;border-top:1.5px solid #000;border-bottom:1.5px solid #000;padding:4px 0;margin:12px 0 4px;text-transform:uppercase}
.qpb-sub{text-align:center;font-weight:600;margin-bottom:6px}
.qpb-q{display:flex;gap:8px;margin:7px 0}
.qpb-qn{min-width:26px;font-weight:700}
.qpb-qb{flex:1;min-width:0}
.qpb-qm{min-width:34px;text-align:right;font-weight:700;white-space:nowrap}
.qpb-opts{display:grid;grid-template-columns:1fr 1fr;gap:3px 16px;margin-top:4px}
.qpb-opts.two{grid-template-columns:1fr}
.qpb-or{text-align:center;font-weight:700;margin:6px 0}
.qpb-match{border-collapse:collapse;margin-top:4px;width:100%}
.qpb-match td,.qpb-match th{border:1px solid #000;padding:2px 8px;text-align:left}
.qpb-grid2{display:grid;grid-template-columns:1fr 1fr;gap:0 22px}
.qpb-ans{margin-top:3px;padding:3px 8px;border-left:3px solid #000;background:#f2f2f2;font-size:.92em}
.qpb-foot{text-align:center;font-weight:700;margin-top:14px;letter-spacing:1px}
`;
